import { REPORT_USER_TYPES } from '@/helpers/deleted-report-helpers'

export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Files',
        route: 'files',
        icon: 'FileIcon',
      },
    ],
  },
  {
    header: 'Report',
    icon: 'FileTextIcon',
    userTypes: REPORT_USER_TYPES,
    children: [
      {
        title: 'Report cartelle eliminate',
        route: 'deleted-report',
        icon: 'FileTextIcon',
        userTypes: REPORT_USER_TYPES,
      },
    ],
  },
]
